import React from 'react';
import './Textarea.css';

const Textarea = ({ label, name, value, onChange }) => {
  return (
    <div className="textarea-group">
      <label>{label}</label>
      <textarea name={name} value={value} onChange={onChange}></textarea>
    </div>
  );
};

export default Textarea;
